'use client';

import { useState, useEffect } from 'react';
import { CustomerTierModel, } from '../../models'
import { ClipboardX } from 'lucide-react';
import { dateFunc, numberFunc, } from '../../utils'
import Loading from '@/components/Loading';

const customer_tier_model = new CustomerTierModel()

export default function PromotionPage() {
  const [isLoading, setIsLoading] = useState(true);
  const [customer_tiers, setCustomerTiers] = useState<any>([]);

  useEffect(() => {
    (async () => {
      try {
        const customer_tiers = await customer_tier_model.getCustomerTierBy({ now: 1 })
        console.log(customer_tiers);
        
        setCustomerTiers(customer_tiers.data.length ? customer_tiers.data[0] : []);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    })()
  }, []);

  return (
    <div className="p-4 min-h-screen ">
      {isLoading ? <Loading /> : <>
        <div className="grid gap-3 h-[100%]">

          {customer_tiers.customer_tier_code ? <>
            <p className="text-lg font-semibold text-orange-500 mb-2">
              {customer_tiers.customer_tier_name}
            </p>
            <p className="text-sm text-orange-700">
              {`ช่วงเวลากิจกรรม : ${dateFunc.toFormat(customer_tiers.customer_tier_start_date, 'DD/MM/yyyy')} - ${dateFunc.toFormat(customer_tiers.customer_tier_end_date, 'DD/MM/yyyy')}`}
            </p>
            <p className="text-sm text-orange-700">
              {`ช่วงเวลานับยอดซื้อ : ${dateFunc.toFormat(customer_tiers.customer_tier_collect_start_date, 'DD/MM/yyyy')} - ${dateFunc.toFormat(customer_tiers.customer_tier_collect_end_date, 'DD/MM/yyyy')}`}
            </p>
            <p className="text-sm text-orange-700 mb-3">
              {`รายละเอียด : ${customer_tiers.customer_tier_policy}`}
            </p>

            {customer_tiers.customer_tier_lists.map((list: any, idx: number) => (
              <div key={list.customer_tier_list_code} className="bg-white rounded-lg shadow-md overflow-hidden">
                <h4 className={`line-clamp-3 text-orange-500 p-2`}>
                  <p className="float-left text-s">
                    <button className={`w-3 h-3 rounded-full mr-1`} style={{ backgroundColor: list.customer_tier_type_color }}></button>
                    <b>{list.customer_tier_type_name}</b>
                  </p>
                  <p className="float-right text-sm text-orange-400 pt-1">
                    {idx === customer_tiers.customer_tier_lists.length - 1 ? 
                     <>ยอดซื้อ <b>{numberFunc.decimalFix(list.min_price, 0)}</b> บาทขึ้นไป</>
                    :
                     <>ยอดซื้อ <b>{numberFunc.decimalFix(list.min_price, 0)} - {numberFunc.decimalFix(list.customer_tier_list_price, 0)}</b> บาท</>
                    }
                  </p>
                </h4>

                {list.customer_tier_benefits.map((benefit: any, idx2: number) => (
                  <div className="px-3 py-1">
                    <p className="text-sm text-gray-600 line-clamp-2">{`${idx2 + 1}.  ${benefit.customer_tier_benefit_name}`}</p>
                  </div>
                ))} 
              </div>
            ))} 
          </> : 
            <div className="w-full flex-1 flex items-center justify-center text-gray-500 text-center flex-col min-h-[60vh]">
              <ClipboardX className="w-20 h-20"/>
              ไม่พบประวัติการซื้อ
            </div>
          }
        </div>
      </>}
    </div>
  );
}
